<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} User</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input class="checkbox" v-if="field.name === 'active' || field.name === 'status' || field.name === 'emailSubscribe' || field.name === 'emailCleanStatus'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
              <select v-else-if="field.name === 'role'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="width: 500px;" :disabled="!isAdmin">
                <option value="USER">USER</option>
                <option value="ADMIN">ADMIN</option>
                <option value="SUPPORT">SUPPORT</option>
              </select>
              <select v-else-if="field.name === 'region'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="width: 500px;">
                <option v-for="(label, key) in regionList" :key="key" :value="key">{{ label }}</option>
              </select>
              <select v-else-if="field.name === 'videoQuality'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="width: 500px;">
                <option v-for="(val, key) in videoQualityList" :key="key" :value="key">{{ key }}</option>
              </select>
              <input v-else :id="field.name" v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'userId')">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">Save changes</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {User} from '@/model/models'
import AdminService from "@/services/admin-service";
import AuthService from "@/services/auth-service";

export default defineComponent({
  name: 'EventEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        userId : this.$route.params.userId,
        email : this.$route.params.email,
        loginId : this.$route.params.loginId,
        role : this.$route.params.role,
        region : this.$route.params.region,
        videoQuality : this.$route.params.videoQuality,
        emailSubscribe : this.$route.params.emailSubscribe,
        active: this.$route.params.active,
        status: this.$route.params.status,
        emailCleanStatus: this.$route.params.emailCleanStatus,
      },
      editMode: false,
      regionList: [],
      videoQualityList: [],
      fields: [
        { name: "userId", label: "User Id" },
        { name: "email", label: "Email" },
        { name: "loginId", label: "Login Id" },
        { name: "role", label: "Role" },
        { name: "region", label: "Region" },
        { name: "videoQuality", label: "Video Quality" },
        { name: "emailSubscribe", label: "Email Subscribe" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" },
        { name: "emailCleanStatus", label: "emailCleanStatus" },
      ],
      error: ""
    }
  },
  computed: {
    isAdmin() {
      return AuthService.isAdmin()
    }
  },
  created() {
    if (this.$route.params.userId) {
      this.editMode = true;
    }
    const storedRegions = sessionStorage.getItem('regions');
    const storedVideoQualities = sessionStorage.getItem('videoQualityList');
    if (storedRegions && storedVideoQualities) {
      this.regionList = JSON.parse(storedRegions);
      this.videoQualityList = JSON.parse(storedVideoQualities);
    } else {
      AdminService.getUserStaticData().then(() => {
        this.regionList = JSON.parse(sessionStorage.getItem('regions'));
        this.videoQualityList = JSON.parse(sessionStorage.getItem('videoQualityList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new User(
          this.editedConfig.userId ,
          this.editedConfig.email ,
          this.editedConfig.loginId ,
          this.editedConfig.emailSubscribe ,
          this.editedConfig.role ,
          this.editedConfig.region === '' ? null : this.editedConfig.region ,
          this.editedConfig.videoQuality === '' ? null : this.editedConfig.videoQuality ,
          this.editedConfig.status,
          this.editedConfig.active,
          this.editedConfig.emailCleanStatus
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateUser(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the /stripe page
          this.$router.push({ name: 'Users' });
        }).catch((error) => {
          console.error("Error updating Users:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      }
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
